import Icon from '../components/Icon.vue'

Icon.register({
  'spray-can': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M224 32C224 14.3 209.7 0 192 0H128C110.3 0 96 14.3 96 32V128H224V32zM480 128C462.3 128 448 142.3 448 160S462.3 192 480 192 512 177.7 512 160 497.7 128 480 128zM224 160H96C43 160 0 203 0 256V480C0 497.7 14.3 512 32 512H288C305.7 512 320 497.7 320 480V256C320 203 277 160 224 160zM160 416C115.8 416 80 380.2 80 336S115.8 256 160 256 240 291.8 240 336 204.2 416 160 416zM480 96C497.7 96 512 81.7 512 64S497.7 32 480 32 448 46.3 448 64 462.3 96 480 96zM384 128C366.3 128 352 142.3 352 160S366.3 192 384 192 416 177.7 416 160 401.7 128 384 128zM288 32C270.3 32 256 46.3 256 64S270.3 96 288 96 320 81.7 320 64 305.7 32 288 32zM384 32C366.3 32 352 46.3 352 64S366.3 96 384 96 416 81.7 416 64 401.7 32 384 32zM480 224C462.3 224 448 238.3 448 256S462.3 288 480 288 512 273.7 512 256 497.7 224 480 224z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/spray-can.js
// module id = /pP+
// module chunks = 144